import React, { memo } from 'react';

export const CustomerCell = memo(({ customerName = '' }) => <span className="customer-link">{customerName}</span>);

export const PlazaCell = memo(({ plazaId = '', plazaName = '', edgeControllerId = '', onPlazaClick = null }) => {
  const handleClick = () => {
    if (onPlazaClick) {
      onPlazaClick(plazaId, plazaName, edgeControllerId);
    }
  };

  const handleKeyDown = (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && onPlazaClick) {
      e.preventDefault();
      e.stopPropagation();
      onPlazaClick(plazaId, plazaName, edgeControllerId);
    }
  };

  return (
    <span className="link" onClick={handleClick} role="button" tabIndex={0} onKeyDown={handleKeyDown}>
      {plazaName}
    </span>
  );
});

export const IdCell = memo(({ value, onClick }) => (
  <span className="link" role="button" tabIndex={0} onClick={() => onClick(value)}>
    {value}
  </span>
));
